"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiaryList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const DiaryItem_1 = require("./DiaryItem");
const react_1 = require("react");
const DiaryListHeader_1 = require("./DiaryListHeader");
const tech_1 = require("../../tech");
const layout_1 = require("../../layout");
function getSortingFunc(key, increasingOrder) {
    return (a, b) => (0, tech_1.sortDates)(a.datum, b.datum, increasingOrder);
}
const sortBySortMethod = (sortMethod, items, sortDirection) => {
    const sortingFunc = getSortingFunc(sortMethod, sortDirection === tech_1.SORT_DIRECTION.UP);
    return items.slice().sort((a, b) => sortingFunc(a, b));
};
const DiaryList = ({ items, getLink }) => {
    const [sortDirection, setSortDirection] = (0, react_1.useState)(tech_1.SORT_DIRECTION.DOWN);
    const [searchQuery, setSearchQuery] = (0, react_1.useState)("");
    const [typeFilter, setTypeFilter] = (0, react_1.useState)("");
    const filtered = typeFilter === "all"
        ? items
        : items.filter((item) => item.typ === typeFilter);
    const stringFilter = (0, tech_1.getFulltextSearch)(searchQuery, filtered, (item) => [
        item.provedl,
        item.email,
        item.uzivatel,
        item.telefon
    ]);
    const itemsSorted = sortBySortMethod(DiaryListHeader_1.DIARY_ENTRY_SORT_METHOD.DATUM, stringFilter, sortDirection);
    return items.length > 0 ? ((0, jsx_runtime_1.jsxs)(layout_1.TabContent, { title: "Seznam hlášení", children: [(0, jsx_runtime_1.jsx)(DiaryListHeader_1.DiaryListHeader, { onTextChange: setSearchQuery, activeEntryType: typeFilter, onActiveEntryTypeChange: (type) => setTypeFilter(type), setSortDirection: setSortDirection, sortDirection: sortDirection, placeholder: "Hledejte dle autora hl\u00E1\u0161en\u00ED..." }), itemsSorted.length > 0
                ? itemsSorted.map((item) => ((0, jsx_runtime_1.jsx)("div", { className: "pb-2", children: (0, jsx_runtime_1.jsx)(DiaryItem_1.DiaryItem, { value: item, link: getLink?.(item) || "../hlaseni/" + item.id }) }, item.id)))
                : "Filtrům neodpovídá žádné deníkové hlášení"] })) : ((0, jsx_runtime_1.jsx)(layout_1.TabEmptyContent, { text: "Zatím zde není žádné deníkové hlášení" }));
};
exports.DiaryList = DiaryList;
